import 'amazon-connect-streams';
import { useEffect, useRef } from 'react';
import { useChatContext } from '../../../contexts/ChatContext';

export function useInitialChatContacts(): void {
  const { setChatContacts } = useChatContext();
  const isInitializedRef = useRef(false);

  useEffect(() => {
    if (isInitializedRef.current) {
      return;
    }
    isInitializedRef.current = true;

    connect.agent(agent => {
      const activeContacts = agent.getContacts(connect.ContactType.CHAT);
      const contactIds = activeContacts.map(contact => contact.getContactId());
      setChatContacts(contactIds);
    });
  }, [setChatContacts]);
}
